module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-spade-fill-3c2dd27f.svg";